import React, { useRef, useState } from "react";
import { Button, Card, Divider } from "antd";
import PoForm from "./PoForm";
import PoDetailList from "./PoDetailList";
import { ProfileTwoTone } from "@ant-design/icons";
import { useModelDispatchers } from "../../../models";
import { CM_ACTION_TYPE, ENV } from "../../../utils/constants";
import { goPage } from "../../layout/pageDefinition";
import { useHistory } from "react-router";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

export default function () {
    const history = useHistory();
    const formRef = useRef();
    const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);
    const { closeNav } = useModelDispatchers("nav");

    const getForm = () => {
        return formRef.current.form();
    };
    const onSave = () => {
        formRef.current.insert(setSaveBtnDisabled);
    }
    const onBack = () => {
        closeNav();
        goPage(history, "2-3");
    }
    const onRepair = () => {
        formRef.current.repair(setSaveBtnDisabled);
    }

    const Title = () => {
        return (
            <div style={{ display: "flex" }}>
                <h3 style={{ flex: "1" }}>
                    <ProfileTwoTone />
                    <span className="margin-left-8">新增采购单</span>
                </h3>
                <div style={{ width: "600px", textAlign: "right" }}>
                    <YhAuth resCode={ResourceAuthEnum.P_AD_REPL}>
                        <Button disabled={saveBtnDisabled} danger onClick={onRepair}>补单</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.P_AD_SAVE}>
                        <Button className="margin-left-8"
                            type="primary"
                            onClick={onSave}
                            disabled={saveBtnDisabled}
                        >
                            保存
                        </Button>
                    </YhAuth>
                    <Button className="margin-left-8"
                        onClick={onBack}
                    >
                        返回
                    </Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title />}
            bordered={true}
            className="margin-top-8"
        >
            {/*<Tabs tabPosition="top">
                <Tabs.TabPane tab="基本信息" key="1">
                    <PoForm formRef={formRef} actionType={CM_ACTION_TYPE.INSERT}/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="商品明细" key="2">
                    <PoDetailList/>
                </Tabs.TabPane>

            </Tabs>*/}
            <PoForm formRef={formRef} actionType={CM_ACTION_TYPE.INSERT} />
            <Divider orientation="left" />
            <PoDetailList getForm={getForm} />
        </Card>
    );
}